import { useApolloClient } from 'react-apollo'
import { logInDev } from './log'
import {
  PW_GET_LATEST_CELLULAR_SUBSCRIPTION,
  PW_GET_STRIPE_CUSTOMER
} from '../../../apollo/api/paywall/queries'

// The old cellular banner and the billing page read their own queries, and after a
// back-bill payment their cached copies still say "expired". Re-reading them from
// the network writes through the cache, so every watcher updates.
export const useRefreshBillingCaches = (accountId?: string) => {
  const client = useApolloClient()

  return async (): Promise<void> => {
    if (!accountId) return
    try {
      const { data } = await client.query({
        query: PW_GET_LATEST_CELLULAR_SUBSCRIPTION,
        variables: { accountId },
        fetchPolicy: 'network-only'
      })
      const stripeCustomerId: string | undefined =
        data?.getLatestCellularSubscription?.stripeCustomerId
      if (!stripeCustomerId) return
      await client.query({
        query: PW_GET_STRIPE_CUSTOMER,
        variables: { stripeCustomerId },
        fetchPolicy: 'network-only'
      })
    } catch (error) {
      // A stale banner elsewhere must not break the payment we just took.
      logInDev('Failed to refresh the cellular billing caches', error)
    }
  }
}
